<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Ney Profit Report {{ (year ? ' ' + year : '') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content ref="contentDiv">
      <v-container grid-list-lg>
        <v-form ref="frmLoadProfit" v-model="frmLoadProfitValid" v-on:submit.prevent>
          <v-layout fluid wrap>
            <v-flex xs6 sm4 offset-sm3>
              <v-select
                v-model="cboYear"
                :items="years"
                label="Year"
                :rules="[v => !!v || 'Year is required']"
                required
              ></v-select>
            </v-flex>
            <v-flex xs3 sm1>
              <v-btn
                outline
                block
                :disabled="!frmLoadProfitValid"
                @click="$router.push('/report/net-profit/' + cboYear)"
              >
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs3 sm1>
              <v-btn
                outline
                block
                :disabled="!frmLoadProfitValid"
                @click="getProfit(cboYear, 'csv')"
              >
                CSV
              </v-btn>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-data-table
                :items="profit.monthly"
                hide-actions
                class="elevation-1"
              >
                <template slot="headers">
                  <tr>
                    <th class="text-xs-center subheading font-weight-bold">
                      Month
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Overall Profit Status
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Net Profit
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Sales
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Cost
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Collected Shipping Cost
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Real Shipping Cost
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Seller Fee
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Payment Fee Received
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Real Payment Fee
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Payment Commission
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Extra Cost
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Expenses
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Other Incomes
                    </th>
                    <th class="text-xs-center subheading font-weight-bold">
                      Voucher
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                    <td class="text-xs-center"><router-link :to="'/report/net-profit/' + year + '/' + props.item.month" target="_blank" class="white--text">{{ props.item.monthName }}</router-link></td>
                    <td :class="'text-xs-center font-weight-bold ' + (props.item.overallProfitStatus === 'complete' ? 'green--text' : 'orange--text')">{{ props.item.overallProfitStatus | allCaps }}</td>
                    <td :class="'text-xs-center font-weight-bold ' + (props.item.netProfitInBase > 0 ? 'green--text' : 'red--text')">{{ formatPrice(props.item.netProfitInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalBranchSalesInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalBranchCostInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalBranchShippingCostInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalBranchRealShippingCostInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalSellerFeeInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalPaymentFeeReceivedInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalPaymentRealFeeInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalPaymentCommissionInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalExtraCostInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalExpensesInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalOtherIncomesInBase) }}</td>
                    <td class="text-xs-center">{{ formatPrice(props.item.totalVoucherInBase) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
            <v-flex xs12 sm3 class="text-xs-left">
              <div>Total Profit: <span :class="'subheading font-weight-bold ' + (profit.totals.netProfitInBase > 0 ? 'green--text' : 'red--text')">{{ def.currency.sign + formatPrice(profit.totals.netProfitInBase) }}</span></div>
              <div>Total Sales: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalBranchSalesInBase) }}</span></div>
              <div>Total Cost: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalBranchCostInBase) }}</span></div>
              <div>Total Collected Shipping Cost: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalBranchShippingCostInBase) }}</span></div>
              <div>Total Real Shipping Cost: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalBranchRealShippingCostInBase) }}</span></div>
              <div>Total Seller Fee: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalSellerFeeInBase) }}</span></div>
              <div>Total Payment Fee Received: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalPaymentFeeReceivedInBase) }}</span></div>
              <div>Total Real Payment Fee: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalPaymentRealFeeInBase) }}</span></div>
              <div>Total Payment Commission: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalPaymentCommissionInBase) }}</span></div>
              <div>Total Extra Cost: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalExtraCostInBase) }}</span></div>
              <div>Total Expenses: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalExpensesInBase) }}</span></div>
              <div>Total Other Incomes: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalOtherIncomesInBase) }}</span></div>
              <div>Total Voucher: <span class="subheading font-weight-bold">{{ def.currency.sign + formatPrice(profit.totals.totalVoucherInBase) }}</span></div>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import downloadjs from 'downloadjs'
import axios from 'axios'

export default {
  props: [
    'year'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      cboYear: '',
      years: [],
      profit: [],
      frmLoadProfitValid: false
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.years = this.generateYearsToCurrentYear(2020)
    if (typeof this.year !== 'undefined' && this.year > 0) {
      this.getProfit(this.year, this.month)
    }
    this.disableBottomDetector()
  },

  methods: {
    getProfit: function (year, format = 'json') {
      var _this = this
      _this.loading = true
      var promise = new Promise(function (resolve, reject) {
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/report/net-profit/' + year + '?format=' + format)
          .then(resp => {
            if (format === 'json') {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                _this.profit = resp.data.data
                _this.cboYear = parseInt(year)
              } else {
                window.alert('Invalid year')
              }
            } else {
              downloadjs(resp.data, 'report.' + format.toLowerCase(), resp.headers['content-type'])
            }
            _this.loading = false
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
            }
            _this.loading = false
          })
      })
      return promise
    }
  }
}
</script>
